import type { EducatorTypeEnum, ProfessionalTypeEnum } from '@gql/graphql';
import type { MapBounds, MapCoordinates } from '@presentation/pages/ProList/components/Map/types';

export interface ProListPageControllerFormValues {
  mapCenter: MapCoordinates;
  zoom: number;
  bounds?: MapBounds;
  maxDistance?: number;
  hasBooking?: boolean;
  spokenLanguages?: string[];
  educatorTypes?: EducatorTypeEnum[];
}

export interface ProListPageControllerProps {
  type: ProfessionalTypeEnum;
}
